import { render, staticRenderFns } from "./IconPoiAirport.vue?vue&type=template&id=0753a253&"
import script from "./IconPoiAirport.vue?vue&type=script&lang=js&"
export * from "./IconPoiAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports